var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14","cy":"14","r":"14","fill":"#f40","key":0}),React.createElement("path",{"d":"M10.052 6.525v14.537c0 .422.666.633 1.054.335l9.49-7.268a.4.4 0 000-.669l-9.49-7.269c-.39-.302-1.054-.091-1.054.334z","fill":"#fff","key":1})]);
}

Video.defaultProps = {"width":"28","height":"28"};

module.exports = Video;

Video.default = Video;
